import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { deliverySoftwareAccessControl } from '../access-control/deliverySoftwareAccess.configuration'

const DeliverySoftwareDeliveryRoutesPage = lazy(
  () => import('../pages/delivery-routes/DeliverySoftwareDeliveryRoutesPage')
)
const DeliverySoftwareDeliveryRouteDetailPage = lazy(
  () => import('../pages/delivery-route-detail/DeliverySoftwareDeliveryRouteDetailPage')
)
// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const deliverySoftwareRouter = (
  <DomainRoute route="delivery-software">
    <DashSwitch>
      <DomainRoute
        exact
        route="delivery-software-delivery-routes"
        accessControl={deliverySoftwareAccessControl}
        component={DeliverySoftwareDeliveryRoutesPage}
      />
      <DomainRoute
        exact
        route="delivery-software-delivery-route-detail"
        accessControl={deliverySoftwareAccessControl}
        component={DeliverySoftwareDeliveryRouteDetailPage}
      />
      {/* @hygen:inject router-route
          injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
